export const screenMediaQueries = (responsiveProps) => (props) => {
  const { screenMediaQueries } = props.theme;
  const result = {};
  Object.keys(responsiveProps).forEach((prop) => {
    if (!screenMediaQueries.has(prop)) {
      result[prop] = responsiveProps[prop];
    }
  });
  screenMediaQueries.forEach((mediaQuery, breakpoint) => {
    if (responsiveProps[breakpoint]) {
      result[mediaQuery] = responsiveProps[breakpoint];
    }
  });
  return result;
};
